import React from "react";

// Última barreira contra a tela branca: qualquer erro de renderização que escape das telas cai aqui
// e vira uma mensagem legível, com o texto técnico para o suporte. Sem isso o React 19 desmonta a
// árvore inteira e o usuário vê só uma página em branco, sem pista do que aconteceu.
interface State {
  error: Error | null;
}

export default class AppErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error("Erro de renderização", error, info.componentStack);
  }

  render(): React.ReactNode {
    if (!this.state.error) return this.props.children;
    const details = `${this.state.error.name}: ${this.state.error.message}\n${navigator.userAgent}`;
    return (
      <div style={{ fontFamily: "system-ui, sans-serif", padding: "24px 16px", maxWidth: 560, margin: "0 auto", color: "#2D3748" }}>
        <h2 style={{ fontSize: "1.1rem", margin: "0 0 8px" }}>Algo deu errado ao montar a tela</h2>
        <p style={{ fontSize: "0.9rem", margin: "0 0 16px", color: "#6c757d" }}>
          Recarregue a página. Se o problema continuar, envie o texto abaixo para o suporte.
        </p>
        <pre style={{ fontSize: "0.72rem", background: "#f1f3f5", padding: 12, borderRadius: 8, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{details}</pre>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{ marginTop: 12, padding: "10px 16px", border: 0, borderRadius: 8, background: "#03B4C6", color: "#fff", fontWeight: 600 }}
        >
          Recarregar
        </button>
      </div>
    );
  }
}
